import { createSlice } from "@reduxjs/toolkit";

import {
  createTips,
  deleteTips,
  duplicateTips,
  fetchTipsDetails,
  listTips,
  updateTips
} from "../../actions/feed/tips";

const tipDetailInitialState = {
  post_id: "",
  description: "",
  primary_tags: [],
  secondary_tags: [],
  categories: [],
  content_type: "FREE",
  user_type: [],
  user_role: [],
  start_date: undefined,
  end_date: undefined,
  is_recurring: false,
  organization: [],
  all_org_access: false,
  all_user_role_access: false,
  all_user_type_access: false
};

const initialState = {
  tipsList: undefined,
  tipsDetails: tipDetailInitialState,
  tipValidationErrors: {},
  tipsListLoading: false,
  tipsDetailsLoading: false,
  tipsCreating: false,
  tipsUpdating: false,
  tipsDeleting: false,
  tipsDuplicating: false
};

export const tipSlice = createSlice({
  name: "tips",
  initialState,
  reducers: {
    resetTipsDetails: (state) => {
      state.tipsDetails = tipDetailInitialState;
      state.tipValidationErrors = {};
    },
    setTipsDetails: (state, { payload }) => {
      state.tipsDetails = { ...state.tipsDetails, ...payload };
      for (const key in payload) {
        if (state.tipValidationErrors[key]) {
          delete state.tipValidationErrors[key];
        }
      }
    },
    validateTip: (state) => {
      const errors = {};
      if (!state.tipsDetails.description) {
        errors.description = "Description is required";
      }
      if (!state.tipsDetails.primary_tags.length) {
        errors.primary_tags = "Primary tags are required";
      }
      if (!state.tipsDetails.secondary_tags.length) {
        errors.secondary_tags = "Secondary tags are required";
      }
      if (!state.tipsDetails.categories.length) {
        errors.categories = "Categories are required";
      }
      if (!state.tipsDetails.content_type) {
        errors.content_type = "Content type is required";
      }
      state.tipValidationErrors = errors;
    }
  },
  extraReducers: {
    [listTips.pending]: (state) => {
      state.tipsListLoading = true;
      state.tipsList = undefined;
    },
    [listTips.fulfilled]: (state, { payload }) => {
      state.tipsList = payload;
      state.tipsListLoading = false;
    },
    [listTips.rejected]: (state) => {
      state.tipsListLoading = false;
    },
    [createTips.pending]: (state) => {
      state.tipsListLoading = true;
    },
    [createTips.fulfilled]: (state) => {
      state.tipsListLoading = false;
    },
    [createTips.rejected]: (state, { error, payload }) => {
      state.tipsListLoading = false;
      state.tipValidationErrors = payload;
    },
    [updateTips.pending]: (state) => {
      state.tipsUpdating = true;
    },
    [updateTips.fulfilled]: (state, { payload }) => {
      state.tipsUpdating = false;
    },
    [updateTips.rejected]: (state, { error, payload }) => {
      state.tipsUpdating = false;
      state.tipValidationErrors = payload;
    },
    [deleteTips.pending]: (state) => {
      state.tipsDeleting = true;
    },
    [deleteTips.fulfilled]: (state) => {
      state.tipsDeleting = false;
    },
    [deleteTips.rejected]: (state) => {
      state.tipsDeleting = false;
    },
    [fetchTipsDetails.pending]: (state) => {
      state.tipsDetailsLoading = true;
      state.tipsDetails = tipDetailInitialState;
    },
    [fetchTipsDetails.fulfilled]: (state, { payload }) => {
      state.tipsDetails = payload;
      state.tipsDetailsLoading = false;
    },
    [fetchTipsDetails.rejected]: (state) => {
      state.tipsDetailsLoading = false;
    },
    [duplicateTips.pending]: (state) => {
      state.tipsDuplicating = true;
    },
    [duplicateTips.fulfilled]: (state) => {
      state.tipsDuplicating = false;
    },
    [duplicateTips.rejected]: (state) => {
      state.tipsDuplicating = false;
    }
  }
});

export const { resetTipsDetails, setTipsDetails, validateTip } =
  tipSlice.actions;

export default tipSlice.reducer;
